import type { SVGProps } from "react";

export function IconPurplePieSlash(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_9193_46191"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="51"
        height="51"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28 53.9548V28H53.9548C53.1798 15.1676 42.5273 5 29.5 5C15.969 5 5 15.969 5 29.5C5 42.5273 15.1676 53.1798 28 53.9548Z"
          fill="#63B2FF"
        />
        <path
          d="M28 53.9548L27.9548 54.7035L28.75 54.7515V53.9548H28ZM28 28V27.25H27.25V28H28ZM53.9548 28V28.75H54.7515L54.7035 27.9548L53.9548 28ZM28.75 53.9548V28H27.25V53.9548H28.75ZM28 28.75H53.9548V27.25H28V28.75ZM29.5 5.75C42.1282 5.75 52.4549 15.6063 53.2062 28.0452L54.7035 27.9548C53.9047 14.7288 42.9263 4.25 29.5 4.25V5.75ZM5.75 29.5C5.75 16.3832 16.3832 5.75 29.5 5.75V4.25C15.5548 4.25 4.25 15.5548 4.25 29.5H5.75ZM28.0452 53.2062C15.6063 52.4549 5.75 42.1282 5.75 29.5H4.25C4.25 42.9263 14.7288 53.9047 27.9548 54.7035L28.0452 53.2062Z"
          fill="#63B2FF"
        />
      </mask>
      <g mask="url(#mask0_9193_46191)">
        <path
          d="M54 29.5C54 43.031 43.031 54 29.5 54C15.969 54 5 43.031 5 29.5C5 15.969 15.969 5 29.5 5C43.031 5 54 15.969 54 29.5Z"
          fill="#2E2E2E"
        />
        <path
          d="M53.25 29.5C53.25 42.6168 42.6168 53.25 29.5 53.25V54.75C43.4452 54.75 54.75 43.4452 54.75 29.5H53.25ZM29.5 53.25C16.3832 53.25 5.75 42.6168 5.75 29.5H4.25C4.25 43.4452 15.5548 54.75 29.5 54.75V53.25ZM5.75 29.5C5.75 16.3832 16.3832 5.75 29.5 5.75V4.25C15.5548 4.25 4.25 15.5548 4.25 29.5H5.75ZM29.5 5.75C42.6168 5.75 53.25 16.3832 53.25 29.5H54.75C54.75 15.5548 43.4452 4.25 29.5 4.25V5.75Z"
          fill="#2E2E2E"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59 34.4661C59 34.4773 59 34.4886 59 34.4999C59 34.5112 59 34.5225 59 34.5338V34.4661ZM58.874 36.9999C57.7 48.5834 48.4569 57.7824 36.8535 58.8883V36.9999H58.874Z"
        fill="#2E2E2E"
      />
      <path
        d="M59 34.4661H58.25L59.75 34.4651L59 34.4661ZM59 34.5338L59.75 34.5348L58.25 34.5338H59ZM36.8535 58.8883L36.9247 59.635L36.1035 59.7132V58.8883H36.8535ZM58.874 36.9999V36.2499H59.7039L59.6202 37.0756L58.874 36.9999ZM36.8535 36.9999H36.1035V36.2499H36.8535V36.9999ZM58.25 34.4999C58.25 34.489 58.25 34.478 58.25 34.4671L59.75 34.4651C59.75 34.4767 59.75 34.4883 59.75 34.4999H58.25ZM58.25 34.5328C58.25 34.5218 58.25 34.5109 58.25 34.4999H59.75C59.75 34.5115 59.75 34.5232 59.75 34.5348L58.25 34.5328ZM58.25 34.5338V34.4661H59.75V34.5338H58.25ZM36.7823 58.1417C48.0293 57.0698 56.9899 48.1519 58.1278 36.9243L59.6202 37.0756C58.4101 49.0149 48.8846 58.4951 36.9247 59.635L36.7823 58.1417ZM36.1035 58.8883V36.9999H37.6035V58.8883H36.1035ZM36.8535 36.2499H58.874V37.7499H36.8535V36.2499Z"
        fill="#2E2E2E"
      />
      <path
        d="M58 8L8 58"
        stroke="#2A222A"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
